import { IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonList, IonItem, IonLabel, IonButtons, IonButton, IonIcon, IonToggle } from "@ionic/react";
import { createOutline } from "ionicons/icons";
import { toggleStyle } from "./SettingsRows";

// The Settings-page building blocks shared by the admin settings pages: a
// titled card with an Edit (or custom) action on the title line, label/value
// rows, and an end-of-row switch.

export function SettingsCard({ id, title, onEdit, action, className = "", children }) {
  return (
    <IonCard id={id} className={className}>
      <IonGrid>
        <IonRow className="ion-align-items-center">
          <IonCol><IonCardHeader><IonCardTitle>{title}</IonCardTitle></IonCardHeader></IonCol>
          {(onEdit || action) && (
            <IonCol size="auto">
              <IonButtons style={{ paddingRight: 4 }}>
                {action || (
                  <IonButton color="dark" fill="clear" className="profile-action" onClick={onEdit}>
                    <IonIcon icon={createOutline} slot="start" /> Edit
                  </IonButton>
                )}
              </IonButtons>
            </IonCol>
          )}
        </IonRow>
      </IonGrid>
      {children}
    </IonCard>
  );
}

export const Muted = ({ children }) => <span style={{ color: "var(--admin-text-muted)" }}>{children}</span>;

// rows: [label, value] shows label over value; [label, null, end] is a
// switch row: the label as the main text and the control (an IonToggle) at
// the row's end, like the Connect buttons on the Settings page.
export function Rows({ rows }) {
  const items = rows.filter(Boolean);
  return (
    <IonList>
      {items.map(([label, value, end], i) => (
        <IonItem key={`${typeof label === "string" ? label : i}-${i}`} lines={i === items.length - 1 ? "none" : undefined}>
          {end && value === null
            ? <IonLabel className="ion-text-wrap">{label}</IonLabel>
            : <IonLabel className="ion-text-wrap"><p>{label}</p>{value === "" || value == null ? <Muted>Not set</Muted> : value}</IonLabel>}
          {end}
        </IonItem>
      ))}
    </IonList>
  );
}

export const Switch = ({ checked, onChange, disabled, label }) => (
  <IonToggle slot="end" checked={checked} disabled={disabled} onIonChange={onChange} style={toggleStyle} aria-label={label} />
);
